import { jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import { d as EGDSLayoutTags } from '../types/index-chunk.esm2.js';
import styles from '../styles/uitk-egds-layout-position.css';

const EGDSLayoutPositionPointerEventsMap = [['none', 'pointerevents-none'], ['auto', 'pointerevents-auto']];
const EGDSLayoutPositionPointerEvents = new Map(EGDSLayoutPositionPointerEventsMap);
const EGDSLayoutPositionTypeMap = [
    ['relative', 'relative'],
    ['sticky', 'sticky'],
    ['absolute', 'absolute'],
    ['fixed', 'fixed'],
];
const EGDSLayoutPositionTypes = new Map(EGDSLayoutPositionTypeMap);
const EGDSLayoutPositionItemZIndexLayerMap = [
    ['layer1', 'layer1'],
    ['layer2', 'layer2'],
    ['layer3', 'layer3'],
    ['layer4', 'layer4'],
    ['layer5', 'layer5'],
    ['layer6', 'layer6'],
    ['layer7', 'layer7'],
];
const EGDSLayoutPositionItemZIndexLayers = new Map(EGDSLayoutPositionItemZIndexLayerMap);
const EGDSLayoutPositionValueMap = [
    ['zero', 'zero'],
    ['half', 'half'],
    ['one', 'one'],
    ['two', 'two'],
    ['three', 'three'],
    ['four', 'four'],
    ['six', 'six'],
    ['twelve', 'twelve'],
    ['minus-half', 'minus-half'],
    ['minus-one', 'minus-one'],
    ['minus-two', 'minus-two'],
    ['minus-three', 'minus-three'],
    ['minus-four', 'minus-four'],
    ['minus-six', 'minus-six'],
    ['minus-twelve', 'minus-twelve'],
    ['center', 'center'],
];
const EGDSLayoutPositionValues = new Map(EGDSLayoutPositionValueMap);

const getClassNameList = classNames.bind(styles);
const EGDSLayoutPosition = (props) => {
    const { children, className, cloneElement, display, pointerEvents, position, style, tag, type, ...attributes } = props;
    const allowCustomPosition = React.useMemo(() => position &&
        Object.values(position).some((v) => typeof v === 'number') &&
        type === EGDSLayoutPositionTypes.get('sticky'), [position, type]);
    const childrenArray = React.Children.toArray(children);
    const firstChild = childrenArray[0];
    if (!firstChild || React.isValidElement(firstChild) === false) {
        return null;
    }
    const firstChildClassName = firstChild.props.className;
    const firstChildStyle = firstChild.props.style;
    const baseClass = 'uitk-layout-position';
    const wrapperClassNames = getClassNameList(baseClass, cloneElement && firstChildClassName && firstChildClassName, display && `${baseClass}-display-${display}`, pointerEvents && `${baseClass}-${EGDSLayoutPositionPointerEvents.get(pointerEvents)}`, position &&
        Object.entries(position)
            .filter(([, val]) => typeof val === 'string')
            .map(([key, val]) => `${baseClass}-${key}-${val}`)
            .join(' '), type && `${baseClass}-${EGDSLayoutPositionTypes.get(type)}`, allowCustomPosition && `${baseClass}-custom`, className);
    const wrapperStyle = {
        ...firstChildStyle,
        ...style,
    };
    if (position && allowCustomPosition) {
        Object.entries(position).forEach(([key, val]) => {
            if (typeof val === 'number') {
                wrapperStyle[`--uitk-custom-${key}-position`] = `${val}px`;
            }
        });
    }
    const decoratedChild = React.cloneElement(firstChild, {
        className: wrapperClassNames,
        ...(Object.keys(wrapperStyle).length && {
            style: wrapperStyle,
        }),
        ...attributes,
    });
    const Tag = ((tag && EGDSLayoutTags.get(tag)) || EGDSLayoutTags.get('div'));
    return cloneElement ? (decoratedChild) : (jsxs(Tag, { className: wrapperClassNames, ...attributes, style: wrapperStyle, children: [' ', children || null, ' '] }));
};
EGDSLayoutPosition.displayName = 'EGDSLayoutPosition';

export { EGDSLayoutPositionPointerEvents as E, EGDSLayoutPositionTypes as a, EGDSLayoutPositionItemZIndexLayers as b, EGDSLayoutPositionValues as c, EGDSLayoutPosition as d };
//# sourceMappingURL=index-chunk.esm.js.map
